import { __read, __spread } from "tslib";
import { Asterisk, Hash, Svg0, Svg1, Svg2, Svg3, Svg4, Svg5, Svg6, Svg7, Svg8, Svg9, } from '@ringcentral/juno-icon';
export var DIALER_PAD_ICONS = [
    [Svg1, '1', ''],
    [Svg2, '2', 'A B C'],
    [Svg3, '3', 'D E F'],
    [Svg4, '4', 'G H I'],
    [Svg5, '5', 'J K L'],
    [Svg6, '6', 'M N O'],
    [Svg7, '7', 'P Q R S'],
    [Svg8, '8', 'T U V'],
    [Svg9, '9', 'W X Y Z'],
    [Asterisk, '*', ''],
    [Svg0, '0', '+'],
    [Hash, '#', ''],
];
export var DIALER_PAD_PLUS = '+';
export var ACCEPTABLE_KEYS = __spread(DIALER_PAD_ICONS.map(function (_a) {
    var _b = __read(_a, 2), value = _b[1];
    return value;
}), [
    DIALER_PAD_PLUS,
]);
